/**
 * Helper for `styled()`-components.
 *
 * Accepts list of prop names that should be blacklisted and returns
 * the `shouldForwardProp` handler (method of optional `styled()` object)
 * that tells `styled()` which properties should be forwarded to the wrapped component.
 *
 * Prop names provided as array of strings (or any quantity of string arguments) to
 * this helper will not be passed/forwarded to DOM.
 * @param {...string} blacklist - array of blacklisted prop names that shouldn't be forwarded
 * @returns {function} - typeof shouldForwardProp
 */
export const youShallNotPass =
  <T = string>(...blacklist: (T | T[])[]): ((prop: string) => boolean) =>
  (propName) =>
    !blacklist.flat().map(String).includes(String(propName))
